<template>
    <div>
        <Navigation :route="navigationRoute"></Navigation>
        <div class="paper-items">
            <div class="paper-item"  v-for="(e, i) in list" :key="i" @click="checkImage(e.certiNum)">
                <el-image
                    style="width: 220px;height: 126px"
                    :src="e.certiImgUrl"
                    :preview-src-list="[e.certiImgUrl]">
                </el-image>
                <div>{{e.name}}</div>
            </div>
        </div>
        <!-- <el-pagination @current-change="handleCurrentChange" background :current-page.sync="query.current"
            :page-size="10" layout="prev, pager, next, jumper" :total="tableData.total">
        </el-pagination> -->
    </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import { myCertificate, start } from "@/api/user.js";
import { mapState, mapMutations } from "vuex";
export default {
    name: "",
    components: {
        Navigation
    },
    data() {
        return {
            navigationRoute: [
                { name: '个人信息' },
                { name: '我的证书' },
            ],
            query: {
                current: 1,
                size: 10
            },
            tableData: { //表格数据
                total: 0,
                records: []
            },
            list:[]
        };
    },
    created() {
        this.getList()
        
    },
    mounted() {
window.cl = this.cl
},

    computed: {

    },
    methods: {
        handleCurrentChange(val) {
            this.query.current = val
            this.getList()
        },
        getList(pageNumber, pageSize) {
           
            this.query.current = pageNumber || this.query.current
            this.query.size = pageSize || this.query.size
            myCertificate(this.query).then(res => {
            this.list = res
            })
        },
        cl() {
            let srcUrl=document.querySelector('.el-image-viewer__img').src;
            this.downloadIamge(srcUrl,this.imgName)
        },
        checkImage(name){//这个事件要绑定el-image父级盒子上
            this.imgName=name
            let a=document.querySelector('.el-image-viewer__actions__inner');
            let ff = document.createElement('i')
            ff.innerHTML = `<i class="el-icon-download" onclick="cl()"></i>`
            a.appendChild(ff)
        },
        downloadIamge(imgsrc, name) {//下载图片地址和图片名
            let image = new Image();
            // 解决跨域 Canvas 污染问题
            image.setAttribute("crossOrigin", "anonymous");
            image.onload = function() {
                let canvas = document.createElement("canvas");
                canvas.width = image.width;
                canvas.height = image.height;
                let context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, image.width, image.height);
                let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
                let a = document.createElement("a"); // 生成一个a元素
                let event = new MouseEvent("click"); // 创建一个单击事件
                a.download = name || "photo"; // 设置图片名称
                a.href = url; // 将生成的URL设置为a.href属性
                a.dispatchEvent(event); // 触发a的单击事件
            };
            image.src = imgsrc;
        },
    },
};
</script>
<style lang="scss" scoped>
.paper-items{
    margin:20px 0 ;
    display: flex;
     justify-content: space-between; 
     flex-wrap: wrap;
    .paper-item{
        color: black;
          flex: 0 0 24%; 
          text-align:center;
          background-color: white;
          /* 边距懒得算，css函数代替 */ 
          margin-right: calc(4% / 3); 
          margin-bottom: calc(4% / 3); 
    }
    .paper-item:nth-child(4n){ 
          margin-right: 0; 
        } 
        /* 使最后一个元素的边距填满剩余空间 */
        .paper-item:last-child{ 
          margin-right: auto; 
        } 
}
</style>